module.exports = __webpack_public_path__ + "static/img/工地-4.3fff8f7b.png";